module.exports = __webpack_public_path__ + "img/empty-logo.50ebb458.svg";